<div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
         <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a [routerLink]="['/home']" >Home</a>
            </li>
            <li class="breadcrumb-item">
                <a>DataBus</a>
            </li>            
            <li class="breadcrumb-item">
                <a>Approve Purchases</a>
            </li>
        </ol>
    </div>
</div>

<div class="wrapper wrapper-content animated fadeInRight">
    <div class="row mt-2">
        <div class="col-lg-12">
            <tabset>
                <tab heading="DataBus Instances" [active]="true">
                    <div class="card mt-2">
                        <div class="card-body">
                            <!-- Instances Without Licenses -->
                            <div class="table-section-header">
                                <h4>Instances Without Licenses ({{instancesWithoutLicenses.length}})</h4>
                            </div>
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th class="sortable-header" (click)="sortTable('without', 'computerName')">Computer Name {{getSortIcon('without', 'computerName')}}</th>
                                        <th class="sortable-header" (click)="sortTable('without', 'customerName')">Customer {{getSortIcon('without', 'customerName')}}</th>
                                        <th class="sortable-header" (click)="sortTable('without', 'startTime')">Start Time {{getSortIcon('without', 'startTime')}}</th>
                                        <th class="sortable-header" (click)="sortTable('without', 'timeStamp')">Last Report {{getSortIcon('without', 'timeStamp')}}</th>
                                        <th class="sortable-header" (click)="sortTable('without', 'totalUris')">URIs {{getSortIcon('without', 'totalUris')}}</th>
                                        <th class="sortable-header" (click)="sortTable('without', 'errorCount')">Errors {{getSortIcon('without', 'errorCount')}}</th>
                                        <th class="sortable-header" (click)="sortTable('without', 'plugins')">Plugins {{getSortIcon('without', 'plugins')}}</th>
                                        <th class="sortable-header" (click)="sortTable('without', 'version')">Version {{getSortIcon('without', 'version')}}</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="instancesWithoutLicenses.length > 0">
                                    <tr class="gradeX" *ngFor="let status of instancesWithoutLicenses">
                                        <td>{{status.computerName}}</td>
                                        <td>{{status.customerName}}</td>
                                        <td>{{status.startTime | relativeDate}}</td>
                                        <td [ngClass]="{'text-danger':convertToDate(status.timeStamp) < oneHourAgo}">{{status.timeStamp | relativeDate}}</td>
                                        <td>{{status.activeUris}} / {{status.totalUris}}</td>
                                        <td>
                                            <span *ngIf="status.errorCount > 0" class="badge bg-danger">{{status.errorCount}}</span>
                                            <span *ngIf="status.errorCount == 0">0</span>
                                        </td>
                                        <td [title]="toList(status.plugins)">{{status.plugins?.length || 0}}</td>
                                        <td>{{status.version}}</td>
                                        <td>
                                            <button (click)="deleteStatus(status)" class="btn btn-outline-danger"><i class="fa fa-trash"></i></button>
                                            <button (click)="showCreateLicense(status);createlicenseModal.show()" class="btn btn-outline-success ml-2"><i class="fa fa-plus"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="instancesWithoutLicenses.length == 0">
                                    <tr class="gradeX">
                                        <td colspan="9">No instances without licenses</td>  
                                    </tr>
                                </tbody>
                            </table>

                            <!-- Instances With Expired Licenses -->
                            <div class="table-section-header">
                                <h4>Instances with Expired Licenses ({{instancesWithExpiredLicenses.length}})</h4>
                            </div>
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th class="sortable-header" (click)="sortTable('expired', 'computerName')">Computer Name {{getSortIcon('expired', 'computerName')}}</th>
                                        <th class="sortable-header" (click)="sortTable('expired', 'customerName')">Customer {{getSortIcon('expired', 'customerName')}}</th>
                                        <th>License</th>
                                        <th class="sortable-header" (click)="sortTable('expired', 'expiry')">Expiry {{getSortIcon('expired', 'expiry')}}</th>
                                        <th class="sortable-header" (click)="sortTable('expired', 'startTime')">Start Time {{getSortIcon('expired', 'startTime')}}</th>
                                        <th class="sortable-header" (click)="sortTable('expired', 'timeStamp')">Last Report {{getSortIcon('expired', 'timeStamp')}}</th>
                                        <th class="sortable-header" (click)="sortTable('expired', 'totalUris')">URIs {{getSortIcon('expired', 'totalUris')}}</th>
                                        <th class="sortable-header" (click)="sortTable('expired', 'errorCount')">Errors {{getSortIcon('expired', 'errorCount')}}</th>
                                        <th class="sortable-header" (click)="sortTable('expired', 'plugins')">Plugins {{getSortIcon('expired', 'plugins')}}</th>
                                        <th class="sortable-header" (click)="sortTable('expired', 'version')">Version {{getSortIcon('expired', 'version')}}</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="instancesWithExpiredLicenses.length > 0">
                                    <tr class="gradeX" *ngFor="let status of instancesWithExpiredLicenses">
                                        <td>{{status.computerName}}</td>
                                        <td>{{status.customerName}}</td>
                                        <td>{{status.installedLicenseId}}</td>
                                        <td class="text-danger">{{status.expiry | relativeDate}}</td>
                                        <td>{{status.startTime | relativeDate}}</td>
                                        <td [ngClass]="{'text-danger':convertToDate(status.timeStamp) < oneHourAgo}">{{status.timeStamp | relativeDate}}</td>
                                        <td>{{status.activeUris}} / {{status.totalUris}}</td>
                                        <td>
                                            <span *ngIf="status.errorCount > 0" class="badge bg-danger">{{status.errorCount}}</span>
                                            <span *ngIf="status.errorCount == 0">0</span>
                                        </td>
                                        <td [title]="toList(status.plugins)">{{status.plugins?.length || 0}}</td>
                                        <td>{{status.version}}</td>
                                        <td>
                                            <button (click)="deleteStatus(status)" class="btn btn-outline-danger"><i class="fa fa-trash"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="instancesWithExpiredLicenses.length == 0">
                                    <tr class="gradeX">
                                        <td colspan="11">No instances with expired licenses</td>  
                                    </tr>
                                </tbody>
                            </table>

                            <!-- Instances With Active Licenses -->
                            <div class="table-section-header">
                                <h4>Instances with Active Licenses ({{instancesWithActiveLicenses.length}})</h4>
                            </div>
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th class="sortable-header" (click)="sortTable('active', 'computerName')">Computer Name {{getSortIcon('active', 'computerName')}}</th>
                                        <th class="sortable-header" (click)="sortTable('active', 'customerName')">Customer {{getSortIcon('active', 'customerName')}}</th>
                                        <th>License</th>
                                        <th class="sortable-header" (click)="sortTable('active', 'expiry')">Expiry {{getSortIcon('active', 'expiry')}}</th>
                                        <th class="sortable-header" (click)="sortTable('active', 'startTime')">Start Time {{getSortIcon('active', 'startTime')}}</th>
                                        <th class="sortable-header" (click)="sortTable('active', 'timeStamp')">Last Report {{getSortIcon('active', 'timeStamp')}}</th>
                                        <th class="sortable-header" (click)="sortTable('active', 'totalUris')">URIs {{getSortIcon('active', 'totalUris')}}</th>
                                        <th class="sortable-header" (click)="sortTable('active', 'errorCount')">Errors {{getSortIcon('active', 'errorCount')}}</th>
                                        <th class="sortable-header" (click)="sortTable('active', 'plugins')">Plugins {{getSortIcon('active', 'plugins')}}</th>
                                        <th class="sortable-header" (click)="sortTable('active', 'version')">Version {{getSortIcon('active', 'version')}}</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf="instancesWithActiveLicenses.length > 0">
                                    <tr class="gradeX" *ngFor="let status of instancesWithActiveLicenses">
                                        <td>{{status.computerName}}</td>
                                        <td>{{status.customerName}}</td>
                                        <td>{{status.installedLicenseId}}</td>
                                        <td [ngClass]="{'text-danger':convertToDate(status.expiry) < inOneMonth,'text-warning':convertToDate(status.expiry) < inTwoMonth}">{{status.expiry | relativeDate}}</td>
                                        <td>{{status.startTime | relativeDate}}</td>
                                        <td [ngClass]="{'text-danger':convertToDate(status.timeStamp) < oneHourAgo}">{{status.timeStamp | relativeDate}}</td>
                                        <td>{{status.activeUris}} / {{status.totalUris}}</td>
                                        <td>
                                            <span *ngIf="status.errorCount > 0" class="badge bg-danger">{{status.errorCount}}</span>
                                            <span *ngIf="status.errorCount == 0">0</span>
                                        </td>
                                        <td [title]="toList(status.plugins)">{{status.plugins?.length || 0}}</td>
                                        <td>{{status.version}}</td>
                                        <td>
                                            <button (click)="deleteStatus(status)" class="btn btn-outline-danger"><i class="fa fa-trash"></i></button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody *ngIf="instancesWithActiveLicenses.length == 0">
                                    <tr class="gradeX">
                                        <td colspan="11">No instances with active licenses</td>  
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </tab>
                <tab heading="New Orders for Approval">
                    <div class="card mt-2">
                        <div class="card-body">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>License ID</th>
                                        <th>License Name</th>
                                        <th>Customer</th>
                                        <th>URI Count</th>
                                        <th>Plugins</th>
                                        <th>Total Price</th>
                                        <th>Status</th>
                                        <th>Creation Date</th>
                                        <th>Valid To</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf ="newOrders.length > 0">
                                    <tr  class="gradeX" *ngFor=" let order of newOrders; let i = index;">
                                        
                                        <!-- todo - Appears as if the order return from the new services doesn't include the commented out keys from below -->
                                        <td>{{ order.licenseId }}</td>
                                        <td>{{ order.licenseName }}</td>
                                        <td>{{ order.customerName }}</td>
                                        <td>{{ order.uriCount }}</td>
                                        <td>{{ order.licensesPlugins.length }}</td>

                                        <td>{{ order.totalPrice | currency }}</td>
                                        <td>{{ order.licenseStatus }}</td>
                                        <td>{{ order.creationDate | date }}</td>
                                        <td *ngIf="order.validTo == null">{{ order.validDayCalc | date }}</td>
                                        <td *ngIf="order.validTo != null">{{ order.validTo | date }}</td>
                                        <td>
                                            <!--<input *ngIf="order.validTo == null" type="number" class="form-control" [ngModel]="order.validDays" (change)="changeDate(order, $event)" min="1" max="1000">-->
                                            <button class="btn btn-primary" (click)="approveOrder(order)">Approve</button>
                                            <button (click)="deleteLicense(order)" class="btn btn-danger ml-2"><i class="fa fa-trash"></i></button>
                                        </td>  
                                    </tr>
                                </tbody>
                                <tbody *ngIf ="newOrders.length == 0">
                                    <tr  class="gradeX">
                                        
                                        <!-- todo - Appears as if the order return from the new services doesn't include the commented out keys from below -->
                                        <td colspan="10">No New Orders</td>  
                                    </tr>
                                </tbody>
                            </table>
                        </div>  
                    </div>
                </tab>
                <tab heading="Active Orders">
                    <div class="card mt-2">
                        <div class="card-body">
                            <table class="table table-striped">
                                <thead>
                                    <tr>
                                        <th>License ID</th>
                                        <th>License Name</th>
                                        <th>Customer</th>
                                        <th>URI Count</th>
                                        <th>Plugins</th>
                                        <th>Total Price</th>
                                        <th>Order Status</th>
                                        <th>Paid Date</th>
                                        <th>Valid To</th>
                                        
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody *ngIf ="approvedOrders.length > 0">
                                    <tr class="gradeX" *ngFor=" let order of approvedOrders; let i = index;">
                                        <td>{{ order.licenseId }}</td>
                                        <td>{{ order.licenseName }}</td>
                                        <td>{{ order.customerName }}</td>
                                        <td>{{ order.uriCount }}</td>
                                        <td>{{ order.licensesPlugins.length }}</td>

                                        <td>{{ order.totalPrice | currency }}</td>
                                        <td>{{ order.licenseStatus }}</td>
                                        <td>{{ order.paidDate | date }}</td>
                                        
                                        <td [ngClass]="{'text-danger':convertToDate(order.validTo) < oneHourAgo}">{{ order.validTo | date }}</td>
                                        
                                        <td>
                                            <button class="btn btn-outline-primary" (click)="revokeOrder(order)">Revoke</button>
                                            <button (click)="deleteLicense(order)" class="btn btn-outline-danger ml-2"><i class="fa fa-trash"></i></button>
                                        </td>  
                                    </tr>
                                </tbody>
                                <tbody *ngIf ="approvedOrders.length == 0">
                                    <tr  class="gradeX">
                                        
                                        <!-- todo - Appears as if the order return from the new services doesn't include the commented out keys from below -->
                                        <td colspan="10">No Approved Orders</td>  
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </tab>
            </tabset>
            
        </div>
    </div>
</div>


<div class="modal fade" bsModal #createlicenseModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">CREATE LICENSE</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" (click)="createlicenseModal.hide()"></button>
      </div>
      <div class="modal-body">
        <div class="row" *ngIf="selectedDataBus">
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Customer Name</label>
              <div class="input-group m-b">
                <select [(ngModel)]="customerId" class="form-select">
                    <option *ngFor="let c of customers" [value]="c.customerId">{{c.customerName}}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-sm-6">
            <div class="form-group input-group-sm">
              <label>Valid Days</label>
              <div class="input-group m-b">
                <input type="text" placeholder="Valid for days" class="form-control" name="name" [(ngModel)]="validFor">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button (click)="createlicenseModal.hide()" class="btn btn-white">Cancel</button>
        <button (click)="createLicense(customerId, selectedDataBus, validFor);createlicenseModal.hide()" class="btn btn-white">Create</button>
      </div>
    </div>
  </div>
</div>